import { keysToCamelCase } from '../../../utils/object';

function AdapterError(status, url, error) {
  this.status = status;
  this.error = error;
  this.url = url;
  this.name = this.constructor.name;
}

AdapterError.prototype = _.create(Error.prototype);

function getUrl(response) {
  const urlFromWixMP = _.get(response, 'config.url');
  return urlFromWixMP || response.url;
}

export default function toError(response = {}) {
  if (response instanceof AdapterError) {
    return Promise.reject(response);
  }

  const { code, status, data = {}, message } = response;
  const url = getUrl(response);

  const dataWithCamelCase = keysToCamelCase(data);
  const { errorCode, errorDescription = message } = dataWithCamelCase;

  return Promise.reject(
    new AdapterError(status || code, url, {
      code: errorCode,
      data: dataWithCamelCase,
      message: errorDescription,
    })
  );
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/parsers/error.js